import 'selectize/dist/js/selectize'
import 'selectize/dist/css/selectize'

window.jQuery(document).ready(function(){
  // Desktop only js library for select
  if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    window.jQuery('.form-control.select').selectize({
      closeAfterSelect: true,
      allowEmptyOption: true
    });
  }
})